export const routes = {
  dashboard: "/dashboard",
  campaigns: "/campaigns",
  calls: "/calls",
  leads: "/contacts",
  appointments: "/appointments",
  knowledgebase: "/knowledgebase",
  settings: "/settings",
};
